import React, { useEffect, useState } from "react";
import { Row, Col, Nav, Card, Badge, Spinner } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../css/DashboardHome.css";
import { formatRupiah } from "../utils/formatRupiah";
import { useTranslation } from "react-i18next";

function DashboardHome() {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState({ name: "Guest" });
  const [reservations, setReservations] = useState([]);
  const [activeTab, setActiveTab] = useState("upcoming");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedUser !== "undefined") {
      try {
        setUser(JSON.parse(storedUser));
      } catch (err) {
        console.error("Error parsing user:", err);
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${process.env.REACT_APP_APP_URL}/get-reservations`, {
        headers: {
          "Content-Type": "application/json",
          "X-Platform": process.env.REACT_APP_X_PLATFORM,
          "API-Key": process.env.REACT_APP_API_KEY,
          "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.success) {
          setReservations(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching reservations:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [i18n.language, t]);

  const upcomingStatuses = ["pending", "confirmed", "checked_in"];
  const completedStatuses = ["completed", "check_out", "reserved", "no_show"];
  const cancelledStatuses = ["cancelled"];

  const filteredReservations = reservations.filter((reservation) => {
    if (activeTab === "upcoming") {
      return upcomingStatuses.includes(reservation.status);
    } else if (activeTab === "completed") {
      return completedStatuses.includes(reservation.status);
    } else if (activeTab === "cancelled") {
      return cancelledStatuses.includes(reservation.status);
    }
    return false;
  });

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    const dateObj = new Date(dateStr);
    return dateObj.toLocaleDateString("en-US", options);
  };

  const handleCardClick = (reservation) => {
    navigate("/dashboard/reservation-detail", { state: { reservation } });
  };

  return (
    <>
      <Nav variant="tabs" activeKey={activeTab} className="mb-4 modern-nav">
        <Nav.Item>
          <Nav.Link
            eventKey="upcoming"
            onClick={() => setActiveTab("upcoming")}
          >
            {t("upcoming")}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey="completed"
            onClick={() => setActiveTab("completed")}
          >
            {t("completed")}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey="cancelled"
            onClick={() => setActiveTab("cancelled")}
          >
            {t("cancelled")}
          </Nav.Link>
        </Nav.Item>
      </Nav>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row>
          {filteredReservations.length > 0 ? (
            filteredReservations.map((reservation) => (
              <Col md={6} lg={4} key={reservation.id} className="mb-4">
                <Card
                  className="modern-card h-100 clickable-card"
                  onClick={() => handleCardClick(reservation)}
                >
                  <Card.Body>
                    <Card.Title className="mb-2 text-success">
                      {reservation.booking_reference || "No Reference"}
                    </Card.Title>
                    <Card.Subtitle className="mb-3 text-muted">
                      {reservation.room_type
                        ? `Room ${reservation.room_type}`
                        : "Room info"}
                    </Card.Subtitle>
                    <Card.Text>
                      <div>
                        <strong>Check In:</strong>{" "}
                        {formatDate(reservation.check_in_date)}
                      </div>
                      <div>
                        <strong>Check Out:</strong>{" "}
                        {formatDate(reservation.check_out_date)}
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer className="bg-transparent border-0">
                    <Badge
                      className="modern-badge text-uppercase"
                      variant="info"
                    >
                      {reservation.status}
                    </Badge>
                  </Card.Footer>
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center p-5 bg-white rounded shadow-sm">
                <h4>
                  {user.name}, {t("youHave")} {activeTab} {t("trips")}
                </h4>
                <p>{t("startPlanning")}</p>
              </div>
            </Col>
          )}
        </Row>
      )}
    </>
  );
}

export default DashboardHome;
